import React from "react";
import classes from "./MatchComparisonProgressBar2.module.css";

const MatchComparisonProgressBar2 = ({ percentage1, percentage2, value1, value2, name }) => {
    const p1 = Math.min(Math.max(Number(percentage1) || 0, 0), 100);
    const p2 = Math.min(Math.max(Number(percentage2) || 0, 0), 100);

    /* decide which side "wins" the bar for colour accent */
    const homeLeads = p1 > p2;
    const awayLeads = p2 > p1;

    return (
        <div className={classes.row}>
            {/* stat label centred */}
            <div className={classes.label}>{name}</div>

            <div className={classes.barRow}>
                {/* home value */}
                <span className={`${classes.val} ${homeLeads ? classes.valWin : ""}`}>{value1}</span>

                {/* dual bar */}
                <div className={classes.track}>
                    {/* home fills from right */}
                    <div className={classes.halfLeft}>
                        <div
                            className={classes.fillLeft}
                            style={{ width: `${p1}%` }}
                        />
                    </div>
                    {/* away fills from left */}
                    <div className={classes.halfRight}>
                        <div
                            className={classes.fillRight}
                            style={{ width: `${p2}%` }}
                        />
                    </div>
                </div>

                {/* away value */}
                <span className={`${classes.val} ${awayLeads ? classes.valWin : ""}`}>{value2}</span>
            </div>
        </div>
    );
};

export default MatchComparisonProgressBar2;